<template>
  <div id="hkWellsoon">
    <div style="position: relative; top: 0; left: 0;">
      <div
        :style="{
          height: `${phoneSearchHeight}px`
        }"
      />
    </div>

    <div style="position: relative; overflow-x: hidden; max-width: 1400px; margin: 0 auto 2vh;">
      <div
        v-if="bannerHeight"
        class="info-container"
        :style="{ height: `${bannerHeight}px` }"
      >
        <div class="title-class">联络我们</div>
        <div class="info-class">
          <span style="padding-right: 16px;">邮箱</span>
          <span>cs＠wellsoon.hk</span>
        </div>
        <div class="info-class">
          <span style="padding-right: 16px;">电话</span>
          <span>+852 3952 6868</span>
        </div>

        <div class="info-class" style="margin-top: 13px;">
          请点击
          <el-link type="primary" href="https://wellsoon.hk/" target="_blank">香港和顺堂官网</el-link>
          查看详情
        </div>
      </div>

      <Banner
        ref="banner"
        :banner-cat-id="15"
        :class="{ banner: true, 'banner-animation': bannerHeight }"
      />
    </div>
  </div>
</template>

<script>
import API from '@/api/service'
// import sideBar from '@/components/sideBar'

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'hkWellsoon',
  // components: {
  //   sideBar
  // },
  data() {
    return {
      innerWidthType: '',
      articleData: [],
      articleInfoDetail: {},
      isShowCould: false,
      parent_id: 0,
      searchData: {
        id: '',
        limit: 10,
        page: 1
      },
      showBanner: false,
      title: '',
      titleFont: {
        33: '门店信息'
      },
      topHeight: 0,
      total: 0,
      jpzyImgHeight: 0,
      phoneSearchHeight: 0,
      bannerHeight: 0
    }
  },
  watch: {
    $route(newVal) {
      const bannerTop = document.querySelector('.banner').clientHeight
      document.body.scrollTop = bannerTop
      document.documentElement.scrollTop = bannerTop
      this.searchData = {
        id: '',
        limit: 10,
        page: 1
      }
      this.getArticleContent()
    }
  },
  created() {
    this.showBanner = true
    this.parent_id = Number(this.$route.params.parent_id)
    this.getArticleContent()
    this.getInnerWidthType()
    window.addEventListener('resize', () => {
      this.getInnerWidthType()
    })
  },
  destroyed() {
    window.removeEventListener('resize', () => {
      this.getInnerWidthType()
    })
  },
  methods: {
    getInnerWidthType() {
      if (window.innerWidth >= 1920) {
        this.innerWidthType = 'xl'
      } else if (window.innerWidth >= 1200) {
        this.innerWidthType = 'lg'
      } else if (window.innerWidth >= 992) {
        this.innerWidthType = 'md'
      } else if (window.innerWidth > 768) {
        this.innerWidthType = 'sm'
      } else {
        this.innerWidthType = 'xs'
      }
      this.$nextTick(() => {
        const timer = setTimeout(() => {
          this.bannerHeight = this.$refs.banner.$el.clientHeight
          clearTimeout(timer)
        }, 1000)
      })
    },
    getArticleContent() {
      this.searchData.id = this.$route.params.id
      this.title = this.titleFont[Number(this.searchData.id)]
      if (this.$route.query.id) {
        const parms = { id: this.$route.query.id }
        API.getArticleDate(parms).then(res => {
          this.articleInfoDetail = res.data
          this.$nextTick(() => {
            setTimeout(() => {
              const oImg = document.querySelector('.wscnph')
              if (oImg) {
                this.jpzyImgHeight = oImg.clientHeight / 2 + 20
              }
            }, 100)
          })
        })
      } else {
        this.searchData.limit = Number(this.$route.params.id) === 33 ? 9 : 10
        API.getArticleList({ ...this.searchData }).then(res => {
          this.articleData = res.data
          this.total = res.count
        })
      }
    },
    handleCurrentChange(val) {
      this.searchData.page = val
      this.getArticleContent()
    },
    setHeight() {
      this.$parent.getHeightList()
    },
    goDetail(data) {
      this.$router.push({
        name: this.$route.name,
        params: {
          parent_id: this.$route.params.parent_id,
          id: this.$route.params.id
        },
        query: { id: data.id }
      })
    },
    setPhoneSearchHeight(data) {
      this.phoneSearchHeight = data
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/hkWellsoon/xl.scss";
// @media screen and (max-width: 1920px) {
//   @import "@/assets/css/hkWellsoon/lg.scss";
// }
// @media screen and (max-width: 1200px) {
//   @import "@/assets/css/hkWellsoon/md.scss";
// }
@media screen and (max-width: 992px) {
  @import "@/assets/css/hkWellsoon/sm.scss";
}
// @media screen and (max-width: 768px) {
//   @import "@/assets/css/hkWellsoon/xs.scss";
// }
</style>



// WEBPACK FOOTER //
// src/view/hkWellsoon.vue